<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core'

interface Iprops {
  active: boolean
  alt: boolean
}

defineProps<Iprops>()

const breakpoints = useBreakpoints(breakpointsTailwind)
const isMobile = breakpoints.smaller('md')
</script>

<template>
  <Transition :name="isMobile ? undefined : 'slide'">
    <div v-show="active" class="menu-container" :class="{ alt }">
      <div class="menu-content">
        <div class="main">
          <slot name="main" />
        </div>

        <div v-if="$slots.aside" class="aside">
          <slot name="aside" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.menu-container {
  --at-apply: lg:border-b-1 lg:border-light-bluish bg-white;
  width: 100%;
  min-height: 350px;
  position: absolute;
  top: 0;
  display: flex;
  z-index: 2;
  transition: 0.3s all;

  @media screen and (max-width: 768px) {
    position: static;
    min-height: unset;
    transition: none;

    .aside {
      display: none;
    }
  }

  &.alt {
    top: 125px;
  }

  .menu-content {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;

    .main {
      width: 60%;
      display: flex;
    }
    .aside {
      --at-apply: bg-gray-lighter;
      width: 40%;
    }
  }
}
@media screen and (max-width: 1350px) {
  .menu-container {
    .menu-content {
      .main {
        width: 90%;
      }
    }
  }
}
</style>
